import React from 'react';
import PropTypes from 'prop-types';

import FinanceMethodPage from 'payment-calculator/components/PaymentCalculatorDetails/components/FinanceMethodPage/FinanceMethodPage.jsx';
import CashMethodPage from 'payment-calculator/components/PaymentCalculatorDetails/components/CashMethodPage/CashMethodPage.jsx';

const PurchaseMethodsTabControlContainer = ({ cashPurchaseSelected, displayCreditRate }) => {
    return (
        <div className="showroom-calculator-new-inner">
            {cashPurchaseSelected ? <CashMethodPage /> : <FinanceMethodPage displayCreditRate={displayCreditRate} />}
        </div>
    );
};

PurchaseMethodsTabControlContainer.defaultProps = {
    displayCreditRate: false,
};
PurchaseMethodsTabControlContainer.propTypes = {
    cashPurchaseSelected: PropTypes.bool.isRequired,
    displayCreditRate: PropTypes.bool,
};

PurchaseMethodsTabControlContainer.displayName = 'PurchaseMethodsTabControlContainer';

export default PurchaseMethodsTabControlContainer;
